import { alertRequest, body, request } from "services/request";

const resource = "api/organizationFeatureModules";
export const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));
export const getList = (id: number) => request(`${resource}/getList/${id}`, { method: "GET" });
export const getPlanningScheduleSettings = (id: number) =>
    request(`${resource}/getPlanningScheduleSettings/${id}`, { method: "GET" });
export const editPlanningScheduleSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editPlanningScheduleSettings/${id}`, body(params));
export const getRefuelingSettings = (id: number) =>
    request(`${resource}/getRefuelingSettings/${id}`, { method: "GET" });
export const editRefuelingSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editRefuelingSettings/${id}`, body(params));
export const getAxisLoadMonitoringSettings = (id: number) =>
    request(`${resource}/getAxisLoadMonitoringSettings/${id}`, { method: "GET" });
export const editAxisLoadMonitoringSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editAxisLoadMonitoringSettings/${id}`, body(params));
export const getDriverControlPointsSettings = (id: number) =>
    request(`${resource}/getDriverControlPointsSettings/${id}`, { method: "GET" });
export const editDriverControlPointsSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editDriverControlPointsSettings/${id}`, body(params));
export const getDriverEducationResourceSettings = (id: number) =>
    request(`${resource}/getDriverEducationResourceSettings/${id}`, { method: "GET" });
export const editDriverEducationResourceSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editDriverEducationResourceSettings/${id}`, body(params));
export const getExploitationSettings = (id: number) =>
    request(`${resource}/getExploitationSettings/${id}`, { method: "GET" });
export const editExploitationSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editExploitationSettings/${id}`, body(params));
export const getBillsSettings = (id: number) => request(`${resource}/getBillsSettings/${id}`, { method: "GET" });
export const editBillsSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editBillsSettings/${id}`, body(params));
export const getTripScenariosSettings = (id: number) =>
    request(`${resource}/getTripScenariosSettings/${id}`, { method: "GET" });
export const editTripScenariosSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editTripScenariosSettings/${id}`, body(params));
export const getNeuralNetworkSettings = (id: number) =>
    request(`${resource}/getNeuralNetworkSettings/${id}`, { method: "GET" });
export const editUnloadPointAdjustmentSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editUnloadPointAdjustmentSettings/${id}`, body(params));
export const getMessengerSettings = (id: number) =>
    request(`${resource}/getMessengerSettings/${id}`, { method: "GET" });
export const editMessengerSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editMessengerSettings/${id}`, body(params));
export const getDocumentAssignmentSettings = (id: number) =>
    request(`${resource}/getDocumentAssignmentSettings/${id}`, { method: "GET" });
export const editDocumentAssignmentSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editDocumentAssignmentSettings/${id}`, body(params));
export const getTrackerLogsFilteringSettings = (id: number) =>
    request(`${resource}/getTrackerLogsFilteringSettings/${id}`, { method: "GET" });
export const editTrackerLogsFilteringSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editTrackerLogsFilteringSettings/${id}`, body(params));
export const getRatingOfDriversAndLogistsSettings = (id: number) =>
    request(`${resource}/getRatingOfDriversAndLogistsSettings/${id}`, { method: "GET" });
export const editRatingOfDriversAndLogistsSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editRatingOfDriversAndLogistsSettings/${id}`, body(params));
export const getForwardingSettings = (id: number) =>
    request(`${resource}/getForwardingSettings/${id}`, { method: "GET" });
export const editForwardingSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editForwardingSettings/${id}`, body(params));
export const getReportSnapshotSettings = (id: number) =>
    request(`${resource}/getReportSnapshotSettings/${id}`, { method: "GET" });
export const editReportSnapshotSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editReportSnapshotSettings/${id}`, body(params));
export const getCrStartSettings = (id: number) =>
    request(`${resource}/getCrStartSettings/${id}`, { method: "GET" });
export const editCrStartSettings = (id: number, params: {}) =>
    alertRequest(`${resource}/editCrStartSettings/${id}`, body(params));
